module.exports = __webpack_public_path__ + "img/profile-img.6380ef5f.png";